import {forwardRef} from 'react';
import DayPickerInput from 'react-day-picker/DayPickerInput';
import {DateUtils} from 'react-day-picker';
import styled from 'styled-components';
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import Calendar from '../images/calendar.svg';
import CalendarNew from '../images/newDesign/Calendar.svg';
import BllinkUtils from './utils/utils';
import 'react-day-picker/lib/style.css';
import {useTranslation} from "react-i18next";

dayjs.extend(customParseFormat);

const BllinkTime = BllinkUtils.BllinkTime;

const StyledDatepicker = styled.div`
  .DayPickerInput {
    position: relative;
    &::before {
      content: '';
      position: absolute;
      inset-inline-end: 14px;
      top: 13px;
      width: 25px;
      height: 25px;
      background-image: url(${Calendar});
      background-repeat: no-repeat;
      z-index: 9;
    }
    &::after {
      content: '';
      position: absolute;
      inset-inline-end: 0;
      top: 0;
      width: 52px;
      height: 52px;
      border-radius: 50%;
      border: 1px solid var(--bllink-blue);
    }
    & > input {
      padding-inline-end: 60px;
      min-width: 160px;
      font-weight: bold;
    }
  }
  .DayPickerInput-Overlay {
    z-index: 99;
  }
  &.new-design {
    .bllink-input-border {
      height: 40px;
      padding-inline-start: 15px;
      padding-inline-end: 40px;
      border: 0;
      font-size: 14px;
      line-height: 22px;
      box-shadow: 0 3px 10px rgba(89, 102, 137, 0.12);
    }
    .DayPickerInput {
      min-width: 160px;
      &::before {
        inset-inline-end: 14px;
        top: 10px;
        width: 20px;
        height: 20px;
        background-image: url(${CalendarNew});
      }
      &::after {
        display: none;
      }
    }
  }
`;

const WEEKDAYS_SHORT = {
    he: ['א', 'ב', 'ג', 'ד', 'ה', 'ו', 'ש'],
    en: ['U', 'M', 'T', 'W', 'R', 'F', 'S'],
};
const MONTHS = {
    he: [
        'ינואר',
        'פברואר',
        'מרץ',
        'אפריל',
        'מאי',
        'יוני',
        'יולי',
        'אוגוסט',
        'ספטמבר',
        'אוקטובר',
        'נובמבר',
        'דצמבר',
    ],
    en: [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December',
    ],
};
const WEEKDAYS_LONG = {
    he: [
        'ראשון',
        'שני',
        'שלישי',
        'רביעי',
        'חמישי',
        'שישי',
        'שבת',
    ],
    en: [
        'Sunday',
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday',
    ],
};

function CustomOverlay({ classNames, selectedDay, children, ...props }) {
    return (
        <div
            className={classNames.overlayWrapper}
            {...props}
        >
            <div className={classNames.overlay}>
                {children}
            </div>
        </div>
    );
}

export function Datepicker({defaultValue, onDayChange, inputProps, placeholder, classNames, onDayPickerHide, fromMonth, toMonth, containerProps, disabledDays, styledContainerProps}) {

    const { t, i18n } = useTranslation();

    const parseDate = (str) => {
        if (!dayjs(str, ["DD/MM/YYYY", "DD-MM-YYYY"], true).isValid()) return undefined;
        const parsed = BllinkTime.toJsDateFromFormatted(str);
        if (DateUtils.isDate(parsed)) {
            return parsed;
        }

        return undefined;
    }
    const renderInput = forwardRef((props, ref) => (
        <input ref={ref} className={'form-control bllink-input-border date-picker'} {...props} />
    ));

    let value;
    if (!defaultValue) value = null
    else value = /^\d{2}\/\d{2}\/\d{4}$/.test(defaultValue) ? defaultValue : BllinkTime.parseDate(defaultValue);

    return (
        <StyledDatepicker
            {...styledContainerProps}
        >
            <DayPickerInput
                dayPickerProps={{
                    locale: i18n.language,
                    months: MONTHS[i18n.language],
                    weekdaysLong: WEEKDAYS_LONG[i18n.language],
                    weekdaysShort: WEEKDAYS_SHORT[i18n.language],
                    ...(disabledDays && {disabledDays}),
                    ...(fromMonth && {fromMonth}),
                    ...(toMonth && {toMonth}),
                }}
                containerProps={containerProps}
                overlayComponent={CustomOverlay}
                inputProps={inputProps}
                format={'dd/mm/yyyy'}
                placeholder={placeholder}
                classNames={classNames}
                parseDate={parseDate}
                formatDate={date => BllinkTime.parseDate(date)}
                value={value}
                component={renderInput}
                onDayChange={onDayChange}
                keepFocus={false}
                onDayPickerHide={onDayPickerHide}
            />
        </StyledDatepicker>
    );
}
